import React, { useContext, useEffect, useState } from 'react';
import { gridComponents } from 'views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import NoRowOverlay from '../../../holidayMaster/NoRowOverlay';
import { gridStyles } from 'views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { Tooltip } from '@mui/material';
import ADataGrid from 'views/pages/manage/common/data-grid/ADataGrid';
import moment from 'moment';
import { ReactComponent as DownloadIcon } from '../../../../../../../assets/img/svg/downloadBlack.svg'
import DownloadExcel from './DownloadExcel';
import { downLoadFile } from './utils';
import { paymodeNameMpping, statusMapping, statusStyle } from './constant';
import { RolePermissions } from 'appContext';
import { pages } from 'views/pages/manage/common/constant';
import { PermissionContext } from 'appContext';
import { updateRequest } from '../../../../common/utils/methods/commonMethods/utilityMethod';

const BulkListing = ({
    rowData,
    rowCount,
    loader,
    filterForm,
    searchHandler = () => {

    }
}) => {
    const [currentPage, setCurrentPage] = useState()
    const [rows, setRows] = useState([])
    const onChangeHandler = (page = 0) => {
        setCurrentPage(page)
        const req = {
            paymentMode: filterForm?.paymentMode,
            uploadedBy: filterForm?.uploadedBy,
            status: filterForm?.status,
            fromProcessingDate:
              filterForm?.fromProcessingDate && filterForm?.fromProcessingDate,
            toProcessingDate:
              filterForm?.toProcessingDate && filterForm?.toProcessingDate,
          };
          searchHandler(updateRequest(req, page));
        // searchHandler({}, page)
    }

    const userPermissions =
        RolePermissions(
            useContext(PermissionContext),
            pages["paymentCollectionBulk"]["id"]
        ) || [];
    useEffect(() => {
        setRows(rowData)
    }, [rowData])
    const columns = [
        new AGridColDef("seqNo", "Seq No.", false)
            .setMinWidth(50)
            .editable(true)
            .setFlex(0.5)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("fileName", "File Name", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container cursor`}
                        onClick={() => downLoadFile(params?.row?.fileKey)}
                        style={{ color: "#00B0F5", fontSize: "14px", cursor: "pointer" }}
                    >
                        {params.value}
                    </div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("processInstanceId", " Process ID", true)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("updatedOn", "Uploaded On", true)
            .setMinWidth(120)
            .editable(true)
            .setFlex(1.2)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={`${moment(params.value).format('DD-MM-YYYY')} on ${moment(params.value).format('hh:mm A')}`}>
                        <div className={`ellipsis-text-container`}>{`${moment(params.value).format('DD-MM-YYYY')} on ${moment(params.value).format('hh:mm A')}`}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("uploadedBy", "Uploaded By", true)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("paymentMode", "Payment Method", true)
            .setMinWidth(110)
            .editable(true)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{paymodeNameMpping?.[params?.value]}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("status", "Status", true)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`} style={statusStyle?.[params?.value]}>{statusMapping?.[params?.value]??params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        ...(userPermissions?.includes("C") || userPermissions?.includes("U")
            ? [new AGridColDef("action", "Action", false)
                .setMinWidth(80)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (

                    <div className={`ellipsis-text-container cursor`}><DownloadExcel
                        pid={params?.row?.processInstanceId}
                        fileName={params?.row?.fileName}
                        status={params?.row?.status}
                    /></div>

                ))] : []),

    ]
    return (
        <ADataGrid
            removeWrapperContainer
            // rowModesModel={rowModesModel}
            rows={rows || []}
            columns={columns}
            rowId={(row) => JSON.stringify(row)}
            rowHeight={50}
            loading={false}
            rowCount={rowCount}
            currentPage={currentPage}
            nextButtonHandler={onChangeHandler}
            components={{
                ...gridComponents,
                NoRowsOverlay: () => (
                    <NoRowOverlay message={loader ? "Loading..." : null} />
                ),
            }}
            sx={gridStyles}
            //  pageSize={10}
            autoHeight
            pinLastColumn
        // hidePagination={true}
        />
    );
}
export default BulkListing